import { useEffect, useState } from "react";

export const enumTemas = {
  Verde: "Verde",
  Amarillo: "Amarillo",
  Azul: "Azul",
  Azul2: "Azul2",
  Gris: "Gris",
  Blanco: "Blanco",
  Rojo: "Rojo",
  Transparente: "Transparente",
  Negro: "Negro",
};

export const enumTiposToast = {
  success: "success",
  info: "info",
  warn: "warn",
  error: "error",
  secondary: "secondary",
};

export default async function OcultarTeclado() {
  try {
    await 2000;
    window.invokeCSCode("#OCULTARTECLADO#");
    sendMessageToNative("#OCULTARTECLADO#")
  } catch {}
}

// export function DateToFecha(date) {
//   if(!date)
//   date = new Date();
//   return [
//     padTo2Digits(date.getDate()),
//     padTo2Digits(date.getMonth() + 1),
//     date.getFullYear(),
//   ].join('/');
// }
function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

export function sendMessageToNative(message) {
  window.ReactNativeWebView.postMessage(message);
}

export function DateToFecha(Fecha) {
  var date = new Date(Fecha);
  var mes = "" + Number(date.getMonth() + 1);
  while (mes.length < 2) {
    mes = "0" + mes;
  }
  return padTo2Digits(date.getDate()) + "/" + mes + "/" + date.getFullYear();
}

export function DateToTexto(Fecha) {
  var date = new Date(Fecha);
  var mes = "" + Number(date.getMonth() + 1);
  while (mes.length < 2) {
    mes = "0" + mes;
  }
  return date.getFullYear() + "-" + mes + "-" + padTo2Digits(date.getDate());
}

export function FuncionCalcularDiasVencimiento(Fecha, mercaderiaItem) {
  try {
    var current = new Date(Fecha.getTime());
    if (mercaderiaItem.VencimientoPorDia) {
      current.setDate(current.getDate() + mercaderiaItem.VencimientoCantidad);
    } else {
      current.setMonth(current.getMonth() + mercaderiaItem.VencimientoCantidad);
    }
    return current;
  } catch {
    return new Date();
  }
}

export function b64toBlob(content, contentType) {
  contentType = contentType || "";
  const sliceSize = 512;
  // method which converts base64 to binary
  const byteCharacters = window.atob(content);

  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, {
    type: contentType,
  }); // statement which creates the blob
  return blob;
}

export function GetConfiguracion(Codigo, lts) {
  if (lts) {
    var otsis = lts.find((r) => r.Configuracion_sCodigo === Codigo);
    if (!otsis) return "";
    else {
      try {
        return String(otsis.Configuracion_sOpcion);
      } catch {
        return "";
      }
    }
  }
}

export function GetPermiso(Codigo, lts, Operador) {
  if (!lts) return false;
  if (!Operador || Operador.Id === 0) return true;
  if (
    Operador &&
    Operador.Operador &&
    String(Operador.Operador).toLowerCase() === "twins"
  )
    return true;
  if (lts) {
    var otsis = lts.find((r) => r.Permiso_sCodigo === Codigo);
    if (!otsis) return false;
    else {
      try {
        return otsis && otsis.Activo ? true : false;
      } catch {
        return false;
      }
    }
  }
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
    horizontal: String(window.screen.orientation.type)
      .toLowerCase()
      .includes("portrait")
      ? false
      : true,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("orientationchange", handleResize);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);
  return windowDimensions;
}

export const enumTiposCombos = {
  Clientes: "Clientes",
  Pedidos: "Pedidos",
  PedidosDespacho: "PedidosDespacho",
  OrdenesCarga: "OrdenesCarga",
  Abastecedores: "Abastecedores",
  ClientesPorAbastecedores: "ClientesPorAbastecedores",
  Turnos: "Turnos",
  ProcesosCliente: "ProcesosCliente",
  EstanteriasStagingPorDeposito: "EstanteriasStagingPorDeposito",
  MercaderiasCodbarNoConStock: "MercaderiasCodbarNoConStock",
  MercaderiasSalidaPorProceso: "MercaderiasSalidaPorProceso",
  EnvasesSecundariosPorMercaderia: "EnvasesSecundariosPorMercaderia",
  Depositos: "Depositos",
  Usuarios: "Usuarios",
  MercaderiasFiltradasxTipos: "MercaderiasFiltradasxTipos",
  Proveedores: "Proveedores",
  Titulares: "Titulares",
  Mercaderias: "Mercaderias",
  ProveedoresImportacion: "ProveedoresImportacion",
  Establecimientos: "Establecimientos",
  Amparos: "Amparos",
  OrdenesRecepcionAbiertas: "OrdenesRecepcionAbiertas",
  EnvasesPrimarios: "EnvasesPrimarios",
  EnvasesSecundarios: "EnvasesSecundarios",
  Temperaturas: "Temperaturas",
  Calificaciones: "Calificaciones",
  Clasificaciones: "Clasificaciones",
  Destinos: "Destinos",
  Contramarcas: "Contramarcas",
  Conexiones: "Conexiones",
  Mesas: "Mesas",
  MercaderiaCuarteo: "MercaderiaCuarteo",
  TransporteEmpresas: "TransporteEmpresas",
  TransporteEmpresas_Vehiculos: "TransporteEmpresas_Vehiculos",
  TransporteEmpresas_Personas: "TransporteEmpresas_Personas",
  DevolucionCausas: "DevolucionCausas",
  OrdenesTrabajoAbiertas: "OrdenesTrabajoAbiertas",
  PedidosSeleccionBarras: "PedidosSeleccionBarras",
  EstadosCC: "EstadosCC",
  ListaOpcionesAnalisis: "ListaOpcionesAnalisis",
  DepositosConsumo: "DepositosConsumo",
  MercaderiasPiSeun: "MercaderiasPiSeun",
  PedidosDetalleIdEnStock: "PedidosDetalleIdEnStock",
  Estados: "Estados",
  DepositosTrans: "DepositosTrans",
  ControlSuperficiesTipos: "ControlSuperficiesTipos",
  ControlSuperficies: "ControlSuperficies",
  ControlSuperficieDescripciones: "ControlSuperficieDescripciones",
  ControlParametros: "ControlParametros",
  ControlParametrosConclusiones: "ControlParametrosConclusiones",
  ControlEtapas: "ControlEtapas",
  ConfiguracionPCs: "ConfiguracionPCs",
  TipoImpresoras: "TipoImpresoras",
  Etiquetas: "Etiquetas",
  MercaderiasPorPlan: "MercaderiasPorPlan",
  MercaderiasSalidasOT: "MercaderiasSalidasOT",
  Especies: "Especies",
  ConsultasReporteCostos175: "ConsultasReporteCostos175",
  ProcesosEnOT: "ProcesosEnOT",
  GestionesCanal: "GestionesCanal",
  GruposMercaderia: "GruposMercaderia",
  MercaderiasPorGrupo: "MercaderiasPorGrupo",
  DepositosTodos: "DepositosTodos",
  Unidades: "Unidades",
  Productos: "Productos",
  Presentaciones: "Presentaciones",
  Calidades: "Calidades",
  CausasRechazoMedias: "CausasRechazoMedias",
  MonedaTipos: "MonedaTipos",
  ListasPrecios: "ListasPrecios",
  ClientesConListasPrecios: "ClientesConListasPrecios",
  NumeradoresFacturas: "NumeradoresFacturas",
  OperadoresCompleto: "OperadoresCompleto",
  MercaderiasTipos: "MercaderiasTipos",
  FormasPago: "FormasPago",
  ListasPreciosVigentes: "ListasPreciosVigentes",
  ListasPreciosVigentesPorCliente: "ListasPreciosVigentesPorCliente",
  DepositosPosicionesTipoEstanteria: "DepositosPosicionesTipoEstanteria",
  BachConsumo: "BachConsumo",
  NumeradoresCobranza: "NumeradoresCobranza",
  CobranzaCajas: "CobranzaCajas",
  Provincias: "Provincias",
  Localidades: "Localidades",
  Bancos: "Bancos",
  BancosSucursales: "BancosSucursales",
  NumeradoresCobranzaAlternos: "NumeradoresCobranzaAlternos",
  LibroIVAGrupos: "LibroIVAGrupos",
  LibroIVAColumnas: "LibroIVAColumnas",
  ComprobantesTipos: "ComprobantesTipos",
  LibroIVACategorias: "LibroIVACategorias",
  NumeradoresPagoProveedores: "NumeradoresPagoProveedores",
  ProveedoresConComprobantesPago: "ProveedoresConComprobantesPago",
  Tipificadores: "Tipificadores",
  PlanesVirtual: "PlanesVirtual",
  ProcesosGrupos: "ProcesosGrupos",
  ProcesosPorGrupo: "ProcesosPorGrupo",
  ReglasPaletizado: "ReglasPaletizado",
  Certificaciones: "Certificaciones",
  Ritos: "Ritos",
  Razas: "Razas",
  SubGruposMercaderia: "SubGruposMercaderia",
  Familias: "Familias",
  Compradores: "Compradores",
  Productores: "Productores",
  EtiquetasPalco: "EtiquetasPalco",
  PlanesFechaGrupo:"PlanesFechaGrupo",
  TiposTrazabilidad:"TiposTrazabilidad",
  PlanesFechasTurno:"PlanesFechasTurno",
  FormatoGrillaNombreConsultas:"FormatoGrillaNombreConsultas",
  Formulas: "Formulas",
};

export function DiaJuliano(Fecha) {
  var start = new Date(Fecha.getFullYear(), 0, 0);
  var diff = Fecha - start;
  var oneDay = 1000 * 60 * 60 * 24;
  var day = Math.floor(diff / oneDay);
  return day;
}

import Swal from "sweetalert2";
export function setStylesError(Mensaje, CodbarInput) {
  return {
    icon: "error",
    theme: "dark",
    title: Mensaje,
    focusConfirm: false,
    allowOutsideClick: false,
    returnFocus: false,
    draggable: true,
    customClass: { confirmButton: "SweeAlert-BotonAlert" },
    didOpen: function () {
      Swal.getConfirmButton().blur();
    },
    didClose: function () {
      CodbarInput && CodbarInput.current && CodbarInput.current.focus();
    },
  };
}

export function MensajeError(Mensaje, CodbarInput) {
  return new Promise((resolve) => {
    Swal.fire({
      icon: "error",
      theme: "dark",
      title: Mensaje,
      focusConfirm: false,
      allowOutsideClick: false,
      returnFocus: false,
      draggable: true,
      customClass: { 
        confirmButton: "SweeAlert-BotonAlert",
        title: "swal-title-font-12"
      },
      didOpen: function () {
        Swal.getConfirmButton().blur();
      },
      didClose: function () {
        CodbarInput && CodbarInput.current && CodbarInput.current.focus();
        resolve(true);
      },
    });
  });
}


export function setStylesInfo(Mensaje, CodbarInput) {
  return {
    icon: "info",
    theme: "dark",
    title: Mensaje,
    focusConfirm: false,
    allowOutsideClick: false,
    returnFocus: false,
    draggable: true,
    customClass: { confirmButton: "SweeAlert-BotonInfo" },
    didOpen: function () {
      Swal.getConfirmButton().blur();
    },
    didClose: function () {
      CodbarInput && CodbarInput.current && CodbarInput.current.focus();
    },
  };
}

export function MensajeInfo(Mensaje, CodbarInput) {
  return new Promise((resolve) => {
    Swal.fire({
      icon: "info",
      theme: "dark",
      title: Mensaje,
      focusConfirm: false,
      allowOutsideClick: false,
      returnFocus: false,
      draggable: true,
      customClass: { 
        confirmButton: "SweeAlert-BotonInfo",
        title: "swal-title-font-12"
      },
      didOpen: function () {
        Swal.getConfirmButton().blur();
      },
      didClose: function () {
        CodbarInput && CodbarInput.current && CodbarInput.current.focus();
        resolve(true);
      },
    });
  });
}


export function MensajeExito(Mensaje, CodbarInput) {
  return new Promise((resolve) => {
    Swal.fire({
      icon: "success",
      theme: "dark",
      title: Mensaje,
      focusConfirm: false,
      allowOutsideClick: false,
      returnFocus: false,
      draggable: true,
      customClass: { 
        confirmButton: "SweeAlert-BotonInfo",
        title: "swal-title-font-12"
      },
      didOpen: function () {
        Swal.getConfirmButton().blur();
      },
      didClose: function () {
        CodbarInput && CodbarInput.current && CodbarInput.current.focus();
        resolve(true);
      },
    });
  });
}



export function setStylesExito(Mensaje, CodbarInput) {
  return {
    icon: "success",
    theme: "dark",
    title: Mensaje,
    focusConfirm: false,
    allowOutsideClick: false,
    returnFocus: false,
    draggable: true,
    customClass: { confirmButton: "SweeAlert-BotonInfo" },
    didOpen: function () {
      Swal.getConfirmButton().blur();
    },
    didClose: function () {
      CodbarInput && CodbarInput.current && CodbarInput.current.focus();
    },
  };
}

export function getMonthFromISOWeekday(year, isoWeek, isoWeekday) {
  let firstDayOfYear = new Date(year, 0, 1);
  let dayOfWeek = firstDayOfYear.getUTCDay();
  let dayOffset = (dayOfWeek <= 4 ? dayOfWeek - 1 : dayOfWeek - 8);
  let isoDate = new Date(year, 0, 1 + (isoWeek - 1) * 7 + isoWeekday - dayOffset);
  return isoDate.getMonth() + 1;
}

export const enumReporteSeleccionado = {
  INGRESOS: "ingresos",
  VENTAS: "ventas",
  PRODUCCION: "produccion",
  DESPACHO: "despacho",
  STOCK: "stock",
  TRAZABILIDAD: "trazabilidad",
};


let globalToastRef = null;

export function setGlobalToastRef(toastRef) {
  globalToastRef = toastRef;
}

export function MensajeToast(mensaje, tipo = "info", duracion = 3000) {
  if (!globalToastRef || !globalToastRef.current) {
    console.warn("Toast no está disponible. Asegúrate de configurar el GlobalToastProvider.");
    return;
  }

  globalToastRef.current.show({
    severity: tipo,
    summary: getTitleBySeverity(tipo),
    detail: mensaje,
    life: duracion
  });
}

export function MensajeToastError(mensaje, duracion = 4000) {
  MensajeToast(mensaje, "error", duracion);
}

export function MensajeToastExito(mensaje, duracion = 3000) {
  MensajeToast(mensaje, "success", duracion);
}

export function MensajeToastAdvertencia(mensaje, duracion = 3000) {
  MensajeToast(mensaje, "warn", duracion);
}

export function MensajeToastInfo(mensaje, duracion = 3000) {
  MensajeToast(mensaje, "info", duracion);
}

function getTitleBySeverity(severity) {
  const titles = {
    success: "Éxito",
    error: "Error", 
    warn: "Advertencia",
    info: "Información",
    secondary: "Mensaje"
  };
  return titles[severity] || "Mensaje";
}
